<template>
  <div class="broadcast-qa">
    <div class="questions">
      <card-minimal title="Unanswered questions" class="no-bg">
        <div v-if="unansweredQuestions.length === 0" class="page-placeholder-text p-a-4 ta-c">
          <p>No unanswered questions to handle</p>
          <p><small>Polling for new questions every 5th second</small></p>
        </div>
        <template v-else>
          <question v-for="(question, index) in unansweredQuestions" :key="`uaq-${index}`" :question="question" />
        </template>
      </card-minimal>
      <card-minimal title="Answered questions" class="no-bg m-t-4">
        <div v-if="answeredQuestions.length === 0" class="page-placeholder-text p-a-4 ta-c">
          <p>No questions has been answered</p>
        </div>
        <template v-else>
          <question v-for="(question, index) in answeredQuestions" :key="`aq-${index}`" @refetch="getQuestions" :question="question" />
        </template>
      </card-minimal>
    </div>
    <div class="options">
      <card-minimal title="Options" class="no-bg">
        <Button class="f-w" @click="setMessage = 'welcome'">
          {{ pinnedMessages && pinnedMessages.welcome !== '' ? 'Change' : 'Set' }} welcome message</Button>
        <Button class="f-w m-t-3" @click="setMessage = 'pinned'">
          {{ pinnedMessages && pinnedMessages.pinned !== '' ? 'Change' : 'Set' }} pinned message</Button>
      </card-minimal>
      <!--<user-list class="f-1 m-t-4" closedText="QA closed" />-->
    </div>
    <portal to="modals">
      <modal :show="setMessage !== ''" @close="setMessage = ''" :title="setMessage === '' ? '' : setMessage === 'pinned' ? 'Set pinned message' : 'Set welcome message'" class="auto-height">
        <div class="p-a-4">
          <form class="d-f" @submit.prevent="updateMessage(setMessage)">
            <FormInput type="text" class="f-w" ref="setMessage" v-model="pinned[setMessage]" :placeholder="setMessage === '' ? '' : setMessage === 'pinned' ? 'Enter pinned message' : 'Enter welcome message'" />
          </form>
        </div>
        <template v-slot:footer>
          <div class="d-f f-w">
            <Button @click="updateMessage(setMessage)">Set message</Button>
            <Button class="red outline ml-a" @click="setMessage = ''">Cancel</Button>
          </div>
        </template>
      </modal>
    </portal>
  </div>
</template>

<script>

import DOMPurify from 'dompurify';
import Question from '@/components/QA/Question.vue';
import { ChatService } from '@/services/chat.service';

export default {
  components: {
    Question,
  },
  computed: {
    /**
     * Return the current broadcast in store
     * @returns {?Object}
     */
    broadcast() {
      return this.$store.getters['Broadcast/current'];
    },
    /**
     * Return unanswered questions
     * @returns {Array}
     */
    unansweredQuestions() {
      return this.questions.filter(question => !question.answered).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    },
    /**
     * Return answered questions
     * @returns {Array}
     */
    answeredQuestions() {
      return this.questions.filter(question => question.answered);
    },
    /**
     * Get the current pinned message
     * @returns {?Object}
     */
    pinnedMessages() {
      return this.$store.getters['Chat/pinnedMessage'](this.broadcast.id);
    },
  },
  methods: {
    /**
     * Get questions
     * @returns {Void}
     */
    async getQuestions() {
      const questions = await this.$store.dispatch('Broadcast/getQuestions', this.broadcast.id);
      this.questions = questions || [];
    },
    /**
     * Set pinned message
     * @param {String} type
     */
    async updateMessage(type) {
      const {
        broadcast: {
          id,
        },
      } = this;
      const message = this.pinned[type];
      await ChatService.setMessage(id, type, DOMPurify.sanitize(message, { ALLOWED_TAGS: [] }));

      this.setMessage = '';
    },
  },
  watch: {
    pinnedMessages: {
      immediate: true,
      handler(messages) {
        if (!messages) {
          return;
        }
        this.pinned = JSON.parse(JSON.stringify(messages));
      },
    },
  },
  data() {
    return {
      questionsInterval: null,
      questions: [],
      setMessage: '',
      pinned: {
        pinned: '',
        welcome: '',
      },
    };
  },
  mounted() {
    this.getQuestions();
    if (!['complete', 'abandoned'].includes(this.broadcast.status.life_cycle_status)) {
      this.questionsInterval = setInterval(() => {
        this.getQuestions();
      }, 5000);
    }
  },
  beforeDestroy() {
    clearInterval(this.questionsInterval);
  },
};
</script>

<style lang="scss" scoped>
</style>

<style lang="scss" scoped>
.broadcast-qa {
  display: flex;
  flex-direction: column;
  width: 100%;

  .questions {
    flex: 2;
  }

  @media (min-width: 768px) {
    flex-direction: row;

    .questions {
    }

    .options {
      margin-left: 25px;
    }
  }
}
</style>
